import { Badge } from '@/components/ui/badge';

interface ProductPricingProps {
  variant?: {
    price: number;
    discount_price?: number | null;
    is_discounted?: boolean;
  } | null;
}

export const ProductPricing = ({ variant }: ProductPricingProps) => {
  if (!variant) return null;

  const price = Number(variant.price) || 0;
  const discountPrice = variant.discount_price ? Number(variant.discount_price) : null;
  const isDiscounted = variant.is_discounted && discountPrice !== null && discountPrice > 0;
  
  const displayPrice = isDiscounted && discountPrice ? discountPrice : price;
  const showDiscount = isDiscounted && discountPrice && discountPrice < price;

  // Don't render if price is 0 or invalid
  if (displayPrice === 0) return null;

  return (
    <div className="flex items-center gap-3 mb-6">
      <span className="text-3xl font-bold text-primary">₹{displayPrice.toFixed(2)}</span>
      {showDiscount && (
        <>
          <span className="text-xl text-gray-500 line-through">₹{price.toFixed(2)}</span>
          <Badge variant="destructive" className="text-sm">
            Save ₹{(price - displayPrice).toFixed(2)}
          </Badge>
        </>
      )}
    </div>
  );
};